import utils from './utils';

const URL = `${BASE_API_URL}/courses`;
const API_V2 = `${BASE_API_URL}/v2/education`;
const STUDENT_URL = `${BASE_API_URL}/student`;
const TEACHER_URL = `${API_V2}/teacher`;
const MANAGER_URL = `${API_V2}/manager`;
/**
* фильтр для получения определенных данных с сервера
*/
const filter =(
  options
)=>
  options
  ? (({
    details,
    uuid,
    lessonID,
    studentID
    })=>
    details
    ? `${details}`
    : uuid
    ? `${uuid}`
    : (lessonID && studentID)
    ? `?lesson=${lessonID}&student=${studentID}`
    : lessonID
    ? `${lessonID}`
    : studentID
    ? `${studentID}`
    : ''
  )(options)
  : '';

export default {
    changeLessonStart: (options, data) => utils.post(`${TEACHER_URL}/lessons/${filter(options)}/change_start/`, data),
    getTeacherHomework: (options) => utils.get(`${TEACHER_URL}/homework/${filter(options)}`),
    getStudentHomework: lessonId => utils.get(`${STUDENT_URL}/lessons/${lessonId}/homework.json`),
    getManagerHomework: (options) => utils.get(`${MANAGER_URL}/homework/${filter(options)}`),
    updateStudentHomework: (lessonId, data) => utils.put(`${STUDENT_URL}/lessons/${lessonId}/homework.json`, data),
    updateTeacherHomework: (options, data) => utils.put(`${TEACHER_URL}/homework/${filter(options)}/`, data),
}



// WEBPACK FOOTER //
// ./src/api/courses.js